// MusicianCard.js - VRAIE SOLUTION avec état unique par ID
import React, { memo, useCallback, useState } from 'react';
import './MusicianCard.css';
import { Link } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';

function MusicianCard({ musician }) {
  // CLEF: État unique basé sur l'ID du musicien
  const [isExpanded, setIsExpanded] = useState(false);

  // Fonction pour truncater le texte
  const truncateBio = useCallback((text, maxLength = 120) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    // Trouve le dernier espace avant la limite pour éviter de couper un mot
    const truncated = text.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');
    return (lastSpaceIndex > 0 ? truncated.substring(0, lastSpaceIndex) : truncated) + '...';
  }, []);

  // Toggle pour expand/collapse - SPÉCIFIQUE À CETTE CARTE
  const toggleBio = useCallback((e) => {
    e.stopPropagation(); // Empêcher la navigation vers le profil
    e.preventDefault(); // Empêcher tout comportement par défaut
    console.log(`Toggle bio for musician: ${musician.name}, ID: ${musician.id}`); // DEBUG
    setIsExpanded(prev => !prev);
  }, [musician.id, musician.name]); // Dependencies claires

  console.log(`Rendering ${musician.name}: isExpanded = ${isExpanded}`); // DEBUG

  return (
    <div className="musician-card" key={musician.id}>
      <OptimizedImage
        src={musician.imageURL}
        alt={musician.name}
        className="musician-image"
      />
      <h3>{musician.name}</h3>
      
      <p>
        <strong>Genre{(musician.genres?.length || 0) > 1 ? 's' : ''} :</strong> {
          musician.genres?.join(', ') || 'Non spécifié'
        }
      </p>
      
      <p><strong>Type :</strong> {musician.type}</p>
      <p><strong>Ville :</strong> {musician.city}</p>
      
      {/* Bio avec bouton voir plus/moins - ÉTAT ISOLÉ */}
      {musician.bio && (
        <div className={`bio-section ${isExpanded ? 'expanded' : ''}`}>
          <p className={`bio ${isExpanded ? 'expanding' : ''}`}>
            {isExpanded ? musician.bio : truncateBio(musician.bio)}
          </p>
          
          {/* Afficher le bouton seulement si la bio est assez longue */}
          {musician.bio.length > 120 && (
            <button 
              className="bio-toggle-btn"
              onClick={toggleBio}
              type="button"
              aria-expanded={isExpanded}
              aria-controls={`bio-${musician.id}`}
            >
              {isExpanded ? 'Voir moins' : 'Voir plus'}
            </button>
          )}
        </div>
      )}

      <Link to={`/musicians/${musician.id}`} className="profile-button">
        Voir le profil
      </Link>
    </div>
  );
}

export default memo(MusicianCard);